export default __webpack_public_path__ + "static/media/cotality-logo.ffb86d05.svg";